/*
DO NOT MANUALLY TRANSLATE!
Follow the instructions in the README.md to conveniently update translations.
*/

export default {
  "CookieMessage.old.link": "További információk",
  "CookieMessage.old.text":
    "Webáruházunk megfelelo muködéséhez sütiket használunk. Tekintse meg a sütik kezelésérol szóló dokumentumot.",
  "CookieMessage.link": "Cookie-k elfogadása",
  "CookieMessage.more_information": "További információk a Kramp cookie-król",
  "CookieMessage.return": "Vissza",
  "CookieMessage.intro.body":
    'A cookie-k a Kramp tól és harmadik féltol is származhatnak. Természetesen rendkívül fontos számunkra az Ön adatainak védelme. A lenti "Cookie-k elfogadása" lehetoségre kattintva Ön beleegyezik a cookie-k használatába. A cookie-k elfogadásával Ön hozzájárul a weboldal megfelelo muködéséhez. Néhány példa a cookie-k használatának céljára:',
  "CookieMessage.intro.list.1": "Automatikus bejelentkezés a Saját fiókjába",
  "CookieMessage.intro.list.2":
    "A látogatói viselkedés elemzése a weboldal fejlesztése céljából",
  "CookieMessage.intro.list.3":
    "Ügyfélprofilok létrehozása, amelynek révén személyre szabott információkat és hirdetéseket biztosíthatunk Önnek",
  "CookieMessage.intro.extra":
    'Amennyiben nem szeretné elfogadni az összes cookie-t, módosítsa a <a>beállításokat</a>. További tudnivalókért tekintse meg az <a href="{legalLink}">adatvédelmi és cookie-kra vonatkozó nyilatkozatunkat</a>.',
  "CookieMessage.intro.title": "A Kramp cookie-kat használ",
  "CookieMessage.settings.body":
    'Három cookie beállítás közül választhat. A "Alapbeállítás" beállítás kiválasztása biztosítja a leheto legjobb élményt weboldalunk használata során.',
  "CookieMessage.settings.standard.title": "Alapbeállítás (a legnépszerubb):",
  "CookieMessage.settings.standard.body":
    "bejelentkezéshez, rendeléshez, elemzéshez, a személyre szabott információkhoz és közösségi oldalakhoz használt cookie-k, illetve az Európán belüli és kívüli harmadik felektol származó cookie-k.",
  "CookieMessage.settings.restricted.title": "Korlátozott:",
  "CookieMessage.settings.restricted.body":
    "A bejelentkezéshez, rendeléshez, elemzéshez és a személyre szabott információkhoz használt cookie-k.",
  "CookieMessage.settings.highly_restricted.title": "Erosen korlátozott:",
  "CookieMessage.settings.highly_restricted.body":
    "Csak minimális számú cookie engedélyezett. Kizárólag a bejelentkezéshez, a rendeléshez, illetve a weboldal alapveto funkcióinak megfelelo muködéséhez.",
  "CookieMessage.settings.options.title": "A következoket tesszük:",
  "CookieMessage.settings.option.1":
    "Cookie-k használata a weboldal megfelelo muködésének biztosítása érdekében",
  "CookieMessage.settings.option.2": "Felhasználói viselkedés kutatása",
  "CookieMessage.settings.option.3": "Személyes statisztikák nyomon követése",
  "CookieMessage.settings.option.4":
    "Az érdeklodésére esetlegesen számot tartó információk megjelenítése",
  "CookieMessage.settings.option.5": "Az adatok felhasználása hirdetéseinkhez",
  "CookieMessage.settings.option.6": "Névtelen statisztikák nyomon követése",
  "CookieMessage.settings.option.7": "Személyes adatainak megosztása",
  "CookieMessage.settings.title": "Cookie beállítások",
  "CookiePage.url": "adatvedelem-cookies",
};
